import React from "react";
import Banner from "../component/Banner";
import BannerImg from "../image/gallaryBanner.png";
import Header from "../component/header";
import Footer from "../component/Footer";
import { quizs } from "../Data/E_Offer";
import { useNavigate } from "react-router-dom";
import { Lock, BrainCircuit, ArrowUpRight } from "lucide-react";
import useAccess from "../hooks/useAccess";

const Quiz = () => {
  const navigate = useNavigate();
  const { canAccessFullQuiz, isFree, isLoggedIn } = useAccess();

  return (
    <div>
      <Header />
      <Banner
        backgroundImage={BannerImg}
        heading="Quiz"
        minHeight="60vh"
        padding="80px 0"
        bton="Members please sign-in"
      />

      <section className="main-lwbl bg-[#F9FAFB] py-16 px-4 rounded-[30px]">
        <div className="max-w-7xl mx-auto">

          {/* Heading */}
          <div className="text-center mb-10">
            <h4 className="font-outfit text-sm md:text-base text-[#555]">
              Stay informed about upcoming quizzes, scoring updates, and interactive learning opportunities
            </h4>
            <h2 className="font-cinzel text-[32px] md:text-[40px] mt-2">
              What's New in Our Quiz Section
            </h2>
            <p className="font-outfit text-sm md:text-base text-[#555] mt-2">
              Knowledge is always in motion. Our quiz calendar keeps you updated on every opportunity to learn and excel.
            </p>
          </div>

          {/* Free tier notice */}
          {isFree && (
            <div className="mb-8 p-4 rounded-2xl bg-amber-50 border border-amber-200 flex items-start gap-3">
              <div className="w-8 h-8 rounded-xl bg-amber-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <BrainCircuit size={16} className="text-amber-600" strokeWidth={2} />
              </div>
              <div className="flex-1">
                <p className="font-outfit font-semibold text-amber-800 text-sm">
                  Free Member — Self-Evaluation Access
                </p>
                <p className="font-outfit text-amber-700 text-xs mt-0.5">
                  As a free member you can browse available quizzes. To attempt quizzes and track your scores, upgrade to Wanderer or higher.
                </p>
                <a href="/membership"
                  className="inline-flex items-center gap-1 mt-2 text-xs font-semibold font-outfit text-amber-800 underline hover:text-amber-900">
                  Upgrade Membership <ArrowUpRight size={12} />
                </a>
              </div>
            </div>
          )}

          {/* Quiz Table */}
          <div className="overflow-x-auto bg-white shadow-lg rounded-2xl border border-gray-100">
            <table className="min-w-full text-left border-collapse">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr>
                  <th className="px-6 py-4 font-outfit text-xs font-semibold text-gray-500 uppercase tracking-wider">Title</th>
                  <th className="px-6 py-4 font-outfit text-xs font-semibold text-gray-500 uppercase tracking-wider">Description</th>
                  <th className="px-6 py-4 font-outfit text-xs font-semibold text-gray-500 uppercase tracking-wider">Questions</th>
                  <th className="px-6 py-4 font-outfit text-xs font-semibold text-gray-500 uppercase tracking-wider text-center">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {quizs.map((data) => (
                  <tr key={data.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <p className="font-outfit font-semibold text-gray-900 text-sm">{data.title}</p>
                    </td>
                    <td className="px-6 py-4 max-w-md">
                      <p className="font-outfit text-sm text-gray-500 truncate">{data.description}</p>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-600 text-xs font-semibold font-outfit border border-blue-100">
                        <BrainCircuit size={11} strokeWidth={2.5} />
                        {data.questions?.length || 0} Qs
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      {canAccessFullQuiz ? (
                        <button
                          onClick={() => navigate(`/attemp-quiz/${data.id}`)}
                          className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gradient-to-r from-[#B6FCFF] to-[#00C3FF] text-black text-xs font-semibold font-outfit hover:scale-105 transition-transform shadow-sm"
                        >
                          Attempt
                        </button>
                      ) : (
                        <button
                          onClick={() => navigate("/membership")}
                          className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-amber-100 text-amber-700 text-xs font-semibold font-outfit hover:bg-amber-200 transition-colors border border-amber-200"
                        >
                          <Lock size={11} strokeWidth={2.5} />
                          Wanderer+
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Quiz;
